import React, { ReactElement } from 'react';

export default function Commercial(props: {
    className?: string;
}): ReactElement {
    const { className } = props;

    return (
        <svg className={className} fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'>
            <path d='M2.5 4C2.5 3.17157 3.17157 2.5 4 2.5H11C11.8284 2.5 12.5 3.17157 12.5 4V21.5H2.5V4Z' stroke='currentColor' />
            <path d='M12.5 13C12.5 12.1716 13.1716 11.5 14 11.5H20C20.8284 11.5 21.5 12.1716 21.5 13V21.5H12.5V13Z' stroke='currentColor' />
            <rect height='0.5' rx='0.25' stroke='currentColor' strokeWidth='0.5' width='3.5' x='15.25' y='14.25' />
            <rect height='12.5' rx='0.25' stroke='currentColor' strokeWidth='0.5' width='0.5' x='5.25' y='5.25' />
            <rect height='12.5' rx='0.25' stroke='currentColor' strokeWidth='0.5' width='0.5' x='9.25' y='5.25' />
            <rect height='0.5' rx='0.25' stroke='currentColor' strokeWidth='0.5' width='3.5' x='15.25' y='16.25' />
            <rect height='0.5' rx='0.25' stroke='currentColor' strokeWidth='0.5' width='3.5' x='15.25' y='18.25' />
        </svg>
    );
}